<div class="mep-dialog-header-icon">
	<mat-icon>info</mat-icon>
</div>
<div class="mep-dialog-title">
	{{ "mep.components.profile-map-extraction-popup.text-extraction-dialog-title" | translate }}
</div>
<div class="mep-dialog-content" mat-dialog-content>
	<p class="explanation-text-top">
		{{ "mep.components.profile-map-extraction-popup.text-extraction-idea" | translate }}
	</p>

	<div class="skills-container">
		@for (skill of data.skills; track skill) {
			<div class="skill-item">
				<p>{{ getSkillName(skill) }} : {{ skill.level }}</p>
			</div>
		}
	</div>

	<p class="explanation-text-bottom">
		{{ "mep.components.profile-map-extraction-popup.text-extraction-confirm-text" | translate }}
	</p>
</div>

<div class="mep-dialog-actions">
	<button class="mep-btn-dialog-secondary" appEscapeHotkey (click)="dialogRef.close()">
		{{ "mep.components.profile-map-extraction-popup.no" | translate }}
	</button>
	<button (click)="onAccept()" class="mep-btn-dialog-primary">
		{{ "mep.components.profile-map-extraction-popup.yes" | translate }}
	</button>
</div>
